import { PERMISSIONS, PermissionValue } from '../domain';

const getVerifyPermission = (permissions: string[] = []) => {
	return (permissionToCheck: PermissionValue | PermissionValue[]) => {
		if (permissions.length === 0) {
			return false;
		}

		if (permissions.includes(PERMISSIONS.siteAdmin)) {
			return true;
		}

		if (Array.isArray(permissionToCheck)) {
			return permissionToCheck.some((permission) => permissions.includes(permission));
		}

		return permissions.includes(permissionToCheck);
	};
};

export default getVerifyPermission;
